import { __module as a } from "./chunk763.js";
import { __require as c } from "./chunk648.js";
import { __require as _ } from "./chunk649.js";
import { __require as h } from "./chunk658.js";
var m = a.exports, d;
function w() {
  return d ? a.exports : (d = 1, function(f, p) {
    (function(n, e, t) {
      f.exports = e(c(), _(), h());
    })(m, function(n) {
      return function() {
        var e = n, t = e.x64, r = t.Word, s = t.WordArray, o = e.algo, i = o.SHA512, x = o.SHA384 = i.extend({
          _doReset: function() {
            this._hash = new s.init([
              new r.init(3418070365, 3238371032),
              new r.init(1654270250, 914150663),
              new r.init(2438529370, 812702999),
              new r.init(355462360, 4144912697),
              new r.init(1731405415, 4290775857),
              new r.init(2394180231, 1750603025),
              new r.init(3675008525, 1694076839),
              new r.init(1203062813, 3204075428)
            ]);
          },
          _doFinalize: function() {
            var u = i._doFinalize.call(this);
            return u.sigBytes -= 16, u;
          }
        });
        e.SHA384 = i._createHelper(x), e.HmacSHA384 = i._createHmacHelper(x);
      }(), n.SHA384;
    });
  }(a), a.exports);
}
export {
  w as __require
};
